<p
  *ngIf="automaticDeliveryConfiguration"
  class="p-0 m-10-px subtle-text small-text italic-text"
>
  Delivery Price will be automatically calculated on save, unless you manually
  enter it. You can update tier delivery settings
  <a href="javascript:void(0);" (click)="openConfigurationDialog()">here.</a>
</p>
<p
  *ngIf="!automaticDeliveryConfiguration"
  class="p-0 m-10-px subtle-text small-text italic-text"
>
  Delivery Price will NOT be automatically calculated on save: you have to
  manually enter it. You can update tier delivery settings
  <a href="javascript:void(0);" (click)="openConfigurationDialog()">here.</a>
</p>

<kendo-dialog
  *ngIf="configurationDialogVisible"
  (close)="configurationDialogVisible = false"
  [width]="600"
  title="Delivery Settings"
>
  <app-configuration></app-configuration>
</kendo-dialog>
